import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_ERROR_MESSAGE', function setErrorMessage(errorMessage: string) {
    teamSetupPickerStore.errorMessage = errorMessage;
});
